import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useData } from "../../../context/DataContext";
import { updateTrainingSession, fileUpload } from '../../../context/createAPI'
import { Box, Card, CardActions, CardContent, Divider, Grid, TextField, CardHeader, Typography, Button, CircularProgress, IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomButton from "../../../components/buttons/customButton";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import DeleteIcon from "@mui/icons-material/Delete"
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


const TrainigSessionFeedBack = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { rowData } = location.state || {};
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const { user = {}, handleTrainingSessions } = useData();

    const [state, setState] = useState({
        feedBackImages: [],
        feedBackComments: "",
        feedBackImagesError: "",
        feedBackCommentError: "",
        responseMessage: "",
        loading: false,
        isUploadLoader: false,
        aveilableCount: "",
        aveilableCountError: "",
    });



    useEffect(() => {
        if (rowData) {
            const currentTime = Math.floor(Date.now() / 1000);

            let sanitizedFeedback = rowData.feedback;

            if (typeof sanitizedFeedback === "string") {
                // Fix escaping
                sanitizedFeedback = sanitizedFeedback.replace(/\\/g, "\\\\");

                try {
                    sanitizedFeedback = JSON.parse(sanitizedFeedback);
                } catch (error) {
                    sanitizedFeedback = null;
                }
            }

            // Ensure it's an array
            const feedbackArray = Array.isArray(sanitizedFeedback) ? sanitizedFeedback : [];

            const feedbackComments = feedbackArray
                .map(item => (item.feedBack || "").replace(/\\n/g, "\n"))
                .join("\n");

            // SAFELY PARSE images
            const photosData =
                typeof rowData?.training_session_photos === "string"
                    ? JSON.parse(rowData.training_session_photos)
                    : rowData?.training_session_photos || [];

            const imagesExist = photosData.map((item) => ({
                fileUrl: item.file,
                fileName: item.fileName || "",
                uploadTime: item.uploadTime || currentTime
            }));

            setState({
                feedBackComments: feedbackComments,
                feedBackImages: imagesExist,
                aveilableCount: rowData?.attended_count
            });
        }
    }, [rowData]);


    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        const readFilesAsBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve({ base64: reader.result, name: file.name, type: file.type });
                reader.onerror = () => reject(new Error('Failed to read file'));
                reader.readAsDataURL(file);
            });
        };

        try {
            setState(prevState => ({
                ...prevState,
                isUploadLoader: true,
            }))
            const newImages = await Promise.all(files.map(file => readFilesAsBase64(file)));
            const createApi = await fileUpload({
                category: "training",
                client_id: 1,
                file: newImages.map((item) => ({
                    file_name: item.name,
                    img: item.base64
                }))
            });

            if (createApi.statusCode === 200) {
                const currentTime = Math.floor(Date.now() / 1000);
                setState(prevState => ({
                    ...prevState,
                    feedBackImages: [
                        ...prevState.feedBackImages ? prevState.feedBackImages : [],
                        ...createApi.data.map(item => ({
                            fileUrl: item.file_url,
                            fileName: item.file_name,
                            uploadTime: currentTime
                        }))
                    ],
                    isUploadLoader: false,
                }));
            }
        } catch (error) {
            console.error(error);
        }
        event.target.value = null;
    };


    const handleDeleteImage = (index) => {
        setState((prevState) => ({ ...prevState, feedBackImages: prevState.feedBackImages.filter((_, i) => i !== index) }));
    };

    const handleFeedBackSubmit = async () => {
        let isValid = false;
        if (!state.feedBackImages.length > 0) {
            setState(prevState => ({ ...prevState, feedBackImagesError: "Upload a File" }));
            isValid = true;
        }
        if (!state.feedBackComments) {
            setState(prevState => ({ ...prevState, feedBackCommentError: "Enter A Valid Comments" }));
            isValid = true;
        }


        if (rowData.training_type_id === 1) {
            setState(prevState => ({ ...prevState, aveilableCountError: "" }));
        } else {
            if (!state.aveilableCount) {
                setState(prevState => ({ ...prevState, aveilableCountError: "Enter A valid Count" }));
                isValid = true;
            }
        }
        if (isValid) {
            return ""
        }

        setState((prevState) => ({ ...prevState, loading: true }));
        try {
            const params = {
                id: rowData?.id,
                session_date: rowData?.session_date ? rowData?.session_date : null,
                ff_group_id: rowData?.group_ids ? rowData?.group_ids : null,
                village_id: rowData?.village_id ? rowData?.village_id : null,
                training_status_id: rowData?.training_Status_id ? rowData?.training_Status_id : null,
                feedback: [{ feedBack: state.feedBackComments }],
                training_session_photos: state.feedBackImages.map((item, index) => ({ id: index + 1, file: item.fileUrl, fileName: item.fileName, uploadTime: item.uploadTime })),
                updated_by: user.user_id ? user.user_id : null,
                attended_count: state.aveilableCount ? state.aveilableCount : null,
                client_id: parseInt(localStorage.getItem("user_client_id")),
            };
            const createApi = await updateTrainingSession(params);
            if (createApi.statusCode === 200) {
                handleTrainingSessions();
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    responseMessage: createApi.message
                }));

                setSnackbar({
                    open: true,
                    message: createApi.message,
                    severity: "success",
                });

                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        } catch (error) {
            console.error(error);

            setSnackbar({
                open: true,
                message: error,
                severity: "success",
            });
        }
    };

    const disabledFun = state.feedBackImages.length > 0 ? false : true


    return (
        <Box>
            <Card elevation={6}>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <CustomButton
                            label="Back"
                            status={false}
                            onClick={() => navigate(-1)}
                            icon={<ArrowBackIcon />}
                        />
                    </Box>

                    <Divider sx={{ my: 1, bgcolor: '#f5f1f1ff' }} />

                    <CardHeader
                        title="Feedback"
                        titleTypographyProps={{
                            fontWeight: "bold",
                            textTransform: "uppercase",
                        }}
                    />

                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, md: 4 }}>
                            <Typography fontWeight="bold" textTransform="uppercase">
                                Upload Files{" "}
                                <Typography component="span" color="error" fontWeight="bold">
                                    {state.feedBackImagesError}
                                </Typography>
                            </Typography>

                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                fullWidth
                                tabIndex={-1}
                                startIcon={<CloudUploadIcon />}
                            >
                                Upload files
                                <VisuallyHiddenInput
                                    type="file"
                                    onChange={handleFileChange}
                                    multiple
                                />
                            </Button>
                        </Grid>

                        {rowData?.training_type_id !== 1 && (
                            <Grid item size={{ xs: 12, md: 4 }}>
                                <Typography fontWeight="bold" textTransform="uppercase">
                                    Attendee Count{" "}
                                    <Typography component="span" color="error" fontWeight="bold">
                                        {state.aveilableCountError}
                                    </Typography>
                                </Typography>

                                <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    value={state.aveilableCount}
                                    placeholder="Enter Training User Count"
                                    onKeyDown={(e) =>
                                        (e.key === "e" || e.key === "E") && e.preventDefault()
                                    }
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value.length <= 3) {
                                            setState((prev) => ({
                                                ...prev,
                                                aveilableCount: value,
                                                aveilableCountError: "",
                                            }));
                                        }
                                    }}
                                    sx={{ mt: 1 }}
                                />
                            </Grid>
                        )}


                        <Grid item size={{ xs: 12, md: 4 }}>
                            <Typography fontWeight="bold" textTransform="uppercase">
                                Enter Comments{" "}
                                <Typography component="span" color="error" fontWeight="bold">
                                    {state.feedBackCommentError}
                                </Typography>
                            </Typography>

                            <TextField
                                fullWidth
                                size="small"
                                multiline
                                rows={2}
                                placeholder="Enter Comments"
                                value={state.feedBackComments}
                                disabled={disabledFun}
                                onChange={(e) =>
                                    setState((prev) => ({
                                        ...prev,
                                        feedBackComments: e.target.value,
                                        feedBackCommentError: "",
                                    }))
                                }
                                sx={{ mt: 1 }}
                            />
                        </Grid>
                    </Grid>


                    <Box mt={3}>
                        {state.isUploadLoader ? (
                            <Box display="flex" justifyContent="center">
                                <CircularProgress />
                            </Box>
                        ) : (
                            <Grid container spacing={2} sx={{ overflowX: "hidden", overflowY: "auto", maxHeight: "50vh" }}>
                                {state.feedBackImages?.map((image, index) => (
                                    <Grid item size={{ xs: 12, md: 4 }} key={index}>
                                        <Box textAlign="center" elevation={6}>
                                            <Box
                                                component="img"
                                                src={image.fileUrl}
                                                alt={image.fileName}
                                                sx={{
                                                    height: 200,
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: 1,
                                                    transition: "0.3s",
                                                    "&:hover": {
                                                        transform: "scale(1.05)",
                                                        boxShadow: 3,
                                                    },
                                                }}
                                            />

                                            <Typography variant="body2" mt={1}>
                                                {image.fileName}
                                            </Typography>

                                            <IconButton
                                                color="error"
                                                onClick={() => handleDeleteImage(index)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Box>
                </CardContent>

                <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                    <CustomButton
                        status={state.loading === true ? "loading" : "idle"}
                        onClick={handleFeedBackSubmit}
                        label="Submit FeedBack"
                        loadingLabel="Submitting.."
                    />
                </CardActions>
            </Card>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Box>
    )
}
export default TrainigSessionFeedBack;